import { Button, Card } from "@aws-amplify/ui-react"
import { Image } from "@aws-amplify/ui-react"
import { Link } from "react-router-dom"
export const PublicHome = ({ }) => {
    return (<div
        className="user-profile-container w-100 h-100 "
        style={{ textAlign: 'start' }}>
        <div className=" d-flex align-items-center my-2 w-100" style={{
            maxWidth: '800px'
        }}>
            <Card variation="elevated">
                <div className="d-flex justify-content-center">
                    <Image src="/pictures/robot.jpg" style={{ maxHeight: '20rem' }} />
                    <div className="m-2 d-flex flex-column justify-content-between" style={{
                        minWidth: '10rem'
                    }}>
                        <div>
                            <h3>Liftolog</h3>
                            <p>Liftolog is a powerful system (Android app + web app) for gym athletes to log workouts, track progress with detailed charts, and share results, media, and insights with buddies or coaches.</p>
                        </div>
                        <div className="d-flex justify-content-end">
                            <Button as={Link} to="/dashboard">Log in</Button>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    </div>)
}